export function getAngularNonce() {
  const metaElement = document.querySelector('meta[data-name="angular-nonce"]') as HTMLMetaElement | null;
  if (metaElement && metaElement.content) {
    return metaElement.content;
  }
  return null;
}
